import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";

export function ThemeProvider({ children }) {
    return (
        <NextThemesProvider
            attribute="class"
            defaultTheme="light"
            enableSystem={false}
            disableTransitionOnChange
        >
            {children}
        </NextThemesProvider>
    );
}

export function ThemeToggle() {
    const { theme, setTheme } = useTheme();
    const isDark = theme === "dark";

    return (
        <button
            data-testid="theme-toggle"
            aria-label="Toggle color theme"
            onClick={() => setTheme(isDark ? "light" : "dark")}
            className="relative grid h-9 w-9 place-items-center rounded-full border border-border bg-background/50 text-foreground transition-colors duration-300 ease-premium hover:bg-secondary"
        >
            <motion.span
                key={isDark ? "moon" : "sun"}
                initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
                animate={{ rotate: 0, opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                className="grid place-items-center"
            >
                {isDark ? (
                    <Moon className="h-[18px] w-[18px]" strokeWidth={1.5} />
                ) : (
                    <Sun className="h-[18px] w-[18px]" strokeWidth={1.5} />
                )}
            </motion.span>
        </button>
    );
}
